import { graphql } from '../../__generated__';

export const PAYMENT_REFERENCE_QUERY = graphql(`
  query PaymentReferenceQuery {
    paymentReferenceNumber
  }
`);
